import React from 'react'
import landImg from'./images/img-1.png';
import'./HomePage.css';
import { Link } from 'react-router-dom';
const LandingPge = () => {

  return (
    <div className='container'>
        <div className='landing'>
        <div className='row'>
            <div className='col-6 land-text'>
                <h2>50% Discount <br/>Online Shop</h2>
                <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration</p>
                <Link to="products">
                <button>Shop Now</button>
                </Link>
            </div>
            <div className='col-6 land-img'>
                <img src={landImg} alt=''/>
            </div>
        </div>
        
    </div>
    </div>
  )
}

export default LandingPge